import configClubEasyFit from './config-club-easyfit'

const config = {
  ...configClubEasyFit,
  // La borne a sa propre entrée r2vel (vel 29, code ef-borne), distincte de celle du
  // site (vel 28, code easy-fit.com) : catalogue et transactions séparés.
  code: 'ef-borne',
  photo: {
    ...configClubEasyFit.photo,
    step: "Contact",
  },
  header: {
    ...configClubEasyFit.header,
    urlLogo: null
  },
  navigation: {
		reinitAuto: true,
		reinitAutoSecs: 300,
		allowChangeClub: false,
	},
  steps: {
    ...configClubEasyFit.steps,
    userForm: {
      ...configClubEasyFit.steps.userForm,
      optins: {
        ...configClubEasyFit.steps.userForm.optins,
        acceptLegal: {
          ...configClubEasyFit.steps.userForm.optins.acceptLegal,
          openInModal: true,
          moreLabel: "Lire les conditions générales",
        },
      },
    },
  },
}

export default config;
